import { atom } from 'recoil';

export const alertDialogState = atom({
  key: 'alertDialogState',
  default: {
    open: false,
    message: '',
    onConfirm: () => {},
  },
});

export const confirmDialogState = atom({
  key: 'confirmDialogState',
  default: {
    open: false,
    message: '',
    onConfirm: () => {},
    onClose: () => {},
  },
});

export const toastState = atom({
  key: 'toastState',
  default: [],
});

export const historyState = atom({
  key: 'historyState',
  default: {
    prev: '/',
    current: '/',
  },
});
